/* A3 integration only: connects unchanged A2 hero links to the live V16 science component.
   No product selection, pricing, cart, analytics or other-template writes. */
(function(){
 'use strict';
 if(window.ECLOCollageneA3){window.ECLOCollageneA3.boot();return;}
 function boot(){
  var marker=document.querySelector('[data-collagene-a3]');
  if(!marker)return;
  var root=marker.closest('[data-ev11-a2]');
  var science=document.querySelector('[id^="EcloScienceV16--"][id$="__science_v5"]');
  if(!root||!science)return;
  root.querySelectorAll('a[href^="#R5Science--"]').forEach(function(link){link.setAttribute('href','#'+science.id);});
  root.dataset.collageneA3Ready='true';
  root.ecloA3Inspect=function(){
   var timeline=document.querySelector('[data-eclo-v14-timeline]');
   var details=root.querySelectorAll('.eclo-v10-detail');
   return {version:'Collagene A3',ready:root.dataset.collageneA3Ready,
    purchase:typeof root.ecloABState==='function'?root.ecloABState():null,
    timelinePeriods:timeline?Array.from(timeline.querySelectorAll('.eclo-v14-timeline__period')).map(function(x){return x.textContent.trim();}):[],
    timelineComponent:timeline?'eclo-supplement-timeline-v14':null,
    studies:science.querySelectorAll('.eclo-science-v16__study').length,
    studyAnchor:science.id,studyLinks:Array.from(root.querySelectorAll('a[href^="#EcloScienceV16--"]')).map(function(x){return x.getAttribute('href');}),
    accordions:Array.from(details).map(function(x){return x.querySelector('summary').textContent.trim();}),
    galleryItems:root.querySelectorAll('[data-v9-media]').length,
    headline:root.querySelector('[data-a2-reference-price]').textContent.trim(),
    cta:root.querySelector('[data-ab-cta]').innerText.trim(),
    horizontalOverflow:document.documentElement.scrollWidth>innerWidth};
  };
 }
 window.ECLOCollageneA3={boot:boot};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',boot);
})();
